import { MoonLoader } from 'react-spinners'

type LoadingProps = { loading?: boolean, size?: number }

export default function Loader({ loading, size }: LoadingProps) {
  return <MoonLoader color={'#f28dbe'} loading={loading ?? true} size={size ?? 60} />
}
